import React from 'react';

const LoadingSpinner = ({ size = 'md', text = '', fullScreen = false }) => {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-10 h-10 border-3',
    lg: 'w-16 h-16 border-4'
  };

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      {/* Lightning Bolt Spinner */}
      <div className="relative">
        <div className={`${sizeClasses[size]} border-[#DC143C]/20 border-t-[#DC143C] rounded-full animate-spin`}></div>
        <svg 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" 
          width={size === 'lg' ? 24 : size === 'md' ? 16 : 10} 
          height={size === 'lg' ? 30 : size === 'md' ? 20 : 12} 
          viewBox="0 0 80 100"
        >
          <path 
            d="M45 0 L25 40 L40 40 L20 70 L35 70 L10 100 L50 60 L35 60 L55 30 L40 30 L60 0 Z" 
            fill="#FFD700"
            className="animate-pulse"
          />
        </svg>
      </div>
      {text && (
        <p className="text-gray-500 text-sm animate-pulse">{text}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-8">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
